<!-- <dashboardnav> -->
    <cradua-incident-owners-mapping
    [incidentOwnersMappings]="incidentOwnersMappings$ | async"
    [owners]="owners$ | async"
    [assetLocations]="assetLocations$ | async"
    (incidentOwnersMapping)="onSubmitIncidentOwnersMapping($event)"
    (deleteIncidentOwnersMappingEvent)="onDeleteIncidentOwnersMapping($event)"    
    *ngIf="
    !(isLoadingIncidentOwnersMapping$ | async ) &&
    !(isLoadingOwners$ | async ) &&
    !(isLoadingAssetLocation$ | async )
    "
    >
  </cradua-incident-owners-mapping>

    <mrsoftapps-epims-reference-spinner 
    *ngIf="
  (isLoadingIncidentOwnersMapping$ | async ) ||
  (isLoadingOwners$ | async ) ||
  (isLoadingAssetLocation$ | async )
  "
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->
